import { render, staticRenderFns } from "./OzLoadingSpinner.vue?vue&type=template&id=19067588&scoped=true&"
import script from "./OzLoadingSpinner.vue?vue&type=script&lang=ts&"
export * from "./OzLoadingSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./OzLoadingSpinner.vue?vue&type=style&index=0&id=19067588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19067588",
  null
  
)

export default component.exports